import { render, staticRenderFns } from "./_InvoiceBlock.vue?vue&type=template&id=a6027574"
import script from "./_InvoiceBlock.vue?vue&type=script&lang=js"
export * from "./_InvoiceBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports